import React from 'react'
import cx from 'classnames'

import BuyTry from '@/components/blocks/BuyTry'
import { Column, Layout, Section } from '@/components/layout'
import { Text } from '@/components/common'
import PricingMain from '@/components/blocks/PricingMain'
import HomePageStats from '@/components/Pages/HomePage/HomePageStats'
import HomePageQuotes from '@/components/Pages/HomePage/HomePageQuotes'
import HomePageFeatures from '@/components/Pages/HomePage/HomePageFeatures'
import styles from '@/components/Pages/HomePage/HomePage.module.scss'
import BuyNowCta from '@/components/BuyNowCta'

const pageId = 'migrationSupport'
const getMessageId = (id) => `pages.migrationSupport.${id}`
const buyCtaMessageId = 'cta.buyNowMigrationSupport'

const promocode = 'MIGRATE100'

const PromoBuyButton = (props) => (
  <BuyTry
    buyCtaMessageId={buyCtaMessageId}
    buySku="neatvipyr"
    canTry={false}
    className={styles.headerBuyTry}
    promocode={promocode}
    {...props}
  />
)

export default function MigrationSupport() {
  return (
    <Layout.Content>
      <Section className={styles.headerSection} wrapperClassName={styles.headerWrapper}>
        <Column className="w-full">
          <div className={styles.heroHolder}>
            <div className={styles.headerTitle}>
              <Text.H1 brandPrimary messageId={getMessageId('main.header.title')} normal size="medium" />
              <Text.H2 messageId={getMessageId('main.header.subtitle')} size="xlarge" />
              <PromoBuyButton justifyStart />
            </div>
          </div>
        </Column>
      </Section>
      <HomePageFeatures replaceCtasWith={<PromoBuyButton justifyCenter />} />
      <HomePageStats replaceCtasWith={<BuyNowCta messageId={buyCtaMessageId} promocode={promocode} sku="neatvipyr" variant="success" />} />
      <HomePageQuotes />
      <Section className={styles.securitySection} wrapperClassName={styles.securityWrapper}>
        <div className={cx(styles.securityTextWrapper, 'max-w-600')}>
          <Text.H2 brandSecondary messageId={getMessageId('security.title')} normal />
          <Text.P messageId={getMessageId('security.p')} onTint />
        </div>
      </Section>
      <Section bgBrandTertiary style={{ backgroundColor: '#E9E8FF' }}>
        <PricingMain
          buyCtaMessageId={buyCtaMessageId}
          canTry={false}
          hideLogos
          isVip
          price="$150/year"
          promocode={promocode}
          strikeThrough="$250"
        />
      </Section>
    </Layout.Content>
  )
}

MigrationSupport.layoutProps = {
  pageId,
  logoOnlyHeader: true,
  showFooter: false,
}
